module.exports = __webpack_public_path__ + "static/media/gi.7b920d10.webp";